import { FileRoutesByPath } from "@tanstack/react-router"

export type RouteKeyType =
  | "LANDING"
  | "BORROW_LANDING"
  | "MUSD_LANDING"
  | "GROWTH_LANDING"
  | "HOME"
  | "HODL"
  | "HODL_WITH"
  | "HODL_ETHEREUM"
  | "DEPOSIT"
  | "ABOUT"
  | "MATS"
  | "LEADERBOARD"
  | "REWARDS"
  | "TERMS"
  | "PRIVACY"
  | "BORROW_OLD"
  | "STORE_OLD"
  | "EARN_OLD"
  | "BORROW"
  | "STORE"
  | "EARN"
  | "SWAP"
  | "AUTH"
  | "VAULT"
  | "EXPLORE"

export const routes: Record<RouteKeyType, keyof FileRoutesByPath> = {
  LANDING: "/",
  BORROW_LANDING: "/feature/borrow",
  MUSD_LANDING: "/feature/musd",
  GROWTH_LANDING: "/vaultcamp",
  HOME: "/home",
  HODL: "/hodl",
  HODL_ETHEREUM: "/hodl-ethereum",
  HODL_WITH: "/hodl-with/$partnerSlug",
  DEPOSIT: "/deposit",
  ABOUT: "/about",
  REWARDS: "/rewards",
  MATS: "/mats",
  LEADERBOARD: "/leaderboard",
  TERMS: "/terms",
  PRIVACY: "/privacy",
  BORROW_OLD: "/matsnet/borrow", // old route for left for correct redirects
  STORE_OLD: "/matsnet/store", // old route for left for correct redirects
  EARN_OLD: "/matsnet/earn", // old route for left for correct redirects
  STORE: "/store",
  BORROW: "/borrow",
  EARN: "/earn",
  SWAP: "/swap",
  AUTH: "/auth",
  VAULT: "/vault",
  EXPLORE: "/explore",
}
